import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import getCreateProgressDownload from "../../DependencyInjection/createProgressDownload";
import Progress from "../../ValueObject/Progress";
import {DownloadProgress} from "../../../../types/downloadManager";

const eventDispatcher = getEventDispatcher();

const DownloadProgressListener: EventHandler<DownloadProgress> = async (event: IpcMainInvokeEvent, content: DownloadProgress): Promise<void> => {
    const progress: Progress = getCreateProgressDownload().create(content);
    await eventDispatcher.dispatch('ChangeProgressDownloadAction', progress);
}

export default DownloadProgressListener;